import axiosInstance from "./axiosInstance";

// api/suportApi.js
export const getPublicNotice = async () => {
  try {
    const res = await axiosInstance.get("/api/admin/notice/public");
    const raw = res?.data?.data;
    const data = Array.isArray(raw) ? raw : raw ? [raw] : [];
    return {
      success: true,
      data,
    };
  } catch (error) {
    return {
      success: false,
      data: [],
      message:
        error.response?.data?.message || "Failed to fetch notice board",
    };
  }
};
